import { useState, useEffect } from 'react'
import { Api } from 'utilities'
import { MultiSelectOption } from 'components/shared/MultiSelect'

interface ProjectResponse {
  id: number
  name: string
  children?: ProjectResponse[]
  [key: string]: any
}

export const useGetProjects = (storeId: number, token: string) => {
  const [projects, setProjects] = useState<MultiSelectOption<number>[]>([])
  const [projectsRawData, setProjectsRawData] = useState<ProjectResponse[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    if (!storeId || !token) {
      setIsLoading(false)
      return
    }

    setIsLoading(true)
    setError(null)

    Api.get<ProjectResponse[]>(`/project/${storeId}/view`, 'marketPlaceApi', {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
      .then((response) => {
        setProjectsRawData(response)

        const transformProject = (project: ProjectResponse): MultiSelectOption<number> => {
          return {
            label: project.name || '',
            value: project.id,
            children: project.children?.map(transformProject) || []
          }
        }

        const transformedProjects: MultiSelectOption<number>[] = response.map(transformProject)
        setProjects(transformedProjects)
        setIsLoading(false)
      })
      .catch((err) => {
        setError(err)
        setIsLoading(false)
        console.error('Error fetching projects:', err)
      })
  }, [storeId, token])

  return { projects, projectsRawData, isLoading, error }
}
